import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaTimes, FaArrowLeft } from "react-icons/fa";
import { TiArrowBack } from "react-icons/ti";
import { connect } from "react-redux";
import { isMobile } from "react-device-detect";
import {
  setCartStage,
  setShowMobileIstand,
} from "../../../redux/actions/cartAction";
import ProductCarTourFlow from "../../common/ProductCarTourFlow";
import ChooseCar from "../../Header/ChooseCar";
import { setLayer } from "../../../redux/actions/globalAction";

const CartHeader = ({
  selection,
  discount,
  getModel,
  apiData,
  globalData,
  getCarBrandModal,
  setShowMobileIstand,
  setLayer,
  cart,
  setCartStage,
}) => {
  const [carBrand, setCarBrand] = useState(null);
  const [carModal, setCarModal] = useState(null);
  const [carLogo, setLogo] = useState(null);
  const [carLogoModal, setLogoModal] = useState(null);
  useEffect(() => {
    let data = globalData;
    setCarBrand(data.carData?.brand);
    setCarModal(data.carData?.modal);
    setLogo(data.carData?.brandUrl);
    setLogoModal(data.carData?.modalUrl);
  }, [globalData]);

  return (
    <>
      {carBrand == null && carModal == null ? (
        <div
          style={{ cursor: "pointer" }}
          className="cart-header justify-content-center py-4"
        >
          {/* <ProductCarTourFlow /> */}
          {/* <a className='workshop-button-one' style={{background:'#fff',border:'1px solid #0451be',borderRadius:'15px',color:'#0451be'}}>Choose Your Car</a> */}
          <ChooseCar
            globalData={globalData}
            style={"choose-car-btn tour-1"}
            text={"Choose Your Car"}
            textTrue={true}
            apiData={apiData}
            getModel={getModel}
            getCarBrandModal={getCarBrandModal}
          />
        </div>
      ) : (
        <div className="cart-header px-3">
          {discount && (
            <div style={{ color: "#F58B1F", fontSize: 12, padding: 5 }}>
              50% discount
            </div>
          )}
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src={carLogo} width={50} alt="carLogo" />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "5px",
              }}
            >
              <span style={{ fontWeight: "bold" }}>{carBrand}</span>
              <span>{carModal}</span>
            </div>
          </div>
          <img src={carLogoModal} alt="carLogoModal" className="car-img" width={130} />
          <ChooseCar
            globalData={globalData}
            style={"change-car"}
            text={"Change Car"}
            textTrue={true}
            apiData={apiData}
            getModel={getModel}
            getCarBrandModal={getCarBrandModal}
            mobileCartView
          />

          {isMobile && cart && cart.stage > 1 ? (
            <TiArrowBack
              style={{ width: "29px", height: "29px" }}
              onClick={() => {
                if (cart.workshop == null || !cart.workshop) {
                  setLayer(false);
                  setShowMobileIstand(false);
                  return;
                }
                setCartStage(cart?.stage - 1);
              }}
            />
          ) : null}

          {isMobile && cart && cart.stage <= 1 ? (
            <FaTimes
              style={{ width: "20px", height: "20px" }}
              onClick={() => {
                setLayer(false);
                setShowMobileIstand(false);
              }}
            />
          ) : null}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    cart: state.cart,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setShowMobileIstand: (flag) => {
      dispatch(setShowMobileIstand(flag));
    },
    setLayer: (status) => {
      dispatch(setLayer(status));
    },
    setCartStage: (stage) => {
      dispatch(setCartStage(stage));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CartHeader);
